import { render, staticRenderFns } from "./CreateOrders.vue?vue&type=template&id=07e90926&scoped=true&"
import script from "./CreateOrders.vue?vue&type=script&lang=js&"
export * from "./CreateOrders.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrders.vue?vue&type=style&index=0&id=07e90926&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e90926",
  null
  
)

export default component.exports